"use client";

import { useLingui } from "@lingui/react/macro";
import { Button, FormInput } from "@offstreetparking/design-system/forms";
import { Heading } from "@offstreetparking/design-system/typography";
import { Form } from "@offstreetparking/portal-flow/components/forms/Form";
import { ButtonRow } from "@offstreetparking/portal-flow/components/layouts/ButtonRow";
import { useId } from "react";
import { useZod } from "~/components/providers/TranslationsProvider";
type LocationStepProps = {
	onSubmit: (locationIdentifier: string) => void;
};
export const LocationStep = ({ onSubmit }: LocationStepProps) => {
	const z = useZod();
	const { t } = useLingui();
	const formId = useId();
	return (
		<Form
			id={formId}
			className="space-y-4 p-8"
			schema={z.object({
				locationIdentifier: z.string().min(1),
			})}
			onSubmit={({ locationIdentifier }) => onSubmit(locationIdentifier)}
		>
			<Heading>{t`Location`}</Heading>
			<FormInput
				name="locationIdentifier"
				label={t`Location identifier`}
				placeholder={t`Enter location identifier`}
				isRequired
			/>
			<ButtonRow>
				<Button type="submit" form={formId} className="w-full text-base md:w-[160px]">
					{t`Lookup`}
				</Button>
			</ButtonRow>
		</Form>
	);
};
